let StreamPrintLogoDirective = (EnvironmentConfigService, CommonLayoutService, Configs) => {
    function loadImage(scope, element, attrs) {
        const attributes = ['printLogo', 'companyLogo'];
        const envConfig = Configs.getEnvironmentConfig();

        if (envConfig) {
            const printLogo = envConfig.printLogo ? envConfig.printLogo['data'] : [];
            const companyLogo = envConfig.companyLogo ? envConfig.companyLogo['data'] : [];
            setLogo(printLogo, companyLogo, attrs);
        }

        if (!envConfig && scope.loadFromDb) {
            return EnvironmentConfigService.details(attributes)
                .then((data) => {
                    if (!data.results) return;
                    const printLogo = data.results.printLogo ? data.results.printLogo['data'] : [];
                    const companyLogo = data.results.companyLogo ? data.results.companyLogo['data'] : [];
                    setLogo(printLogo, companyLogo, attrs);
                })
                .catch(err => {
                    console.log(err);
                })
        }
    };

    function setLogo(printLogo, companyLogo, attrs) {
        if (printLogo.length) {
            const printLogoObjectURL = CommonLayoutService.generateObjectURL(printLogo);
            attrs.$set('src', printLogoObjectURL);
        }
        if (companyLogo.length) CommonLayoutService.updateFavicon(companyLogo);
    }

    return {
        restrict: 'A',
        scope: {
            loadFromDb: "="
        },
        link: loadImage
    }
};

StreamPrintLogoDirective.$inject = ['EnvironmentConfigService', 'CommonLayoutService', 'Configs'];

export default StreamPrintLogoDirective;


// WEBPACK FOOTER //
// ./client/app/common/stream-print-logo/stream-print-logo.directive.js